export const languageMap = {
  'zh-cn': () => import("./locales/zh-cn/index.json"),
  'en': () => import("./locales/en/index.json"),
  'fr': () => import("./locales/fr/index.json")
}

export const supportedLanguages = Object.keys(languageMap)